import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {AuthGuardService} from 'compob2b-auth';
import {ProductViewComponent} from './product-view/product-view.component';
import {ProductAnalogsComponent} from './product-analogs/product-analogs.component';

const routes: Routes = [
  {
    path: '', // path is: /product
    redirectTo: '/catalog',
    pathMatch: 'full',
    data: {
      breadcrumb: {skip: true},
    },
  },
  {
    path: ':uid', // path is: /product/:uid
    component: ProductViewComponent,
    canActivate: [AuthGuardService],
    data: {
      breadcrumb: {skip: true},
    },
  },
  {
    path: ':uid/analogs', // path is: /product/:uid/analogs
    component: ProductAnalogsComponent,
    canActivate: [AuthGuardService],
    data: {
      breadcrumb: {skip: true},
    },
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ProductRoutingModule { }
